import moment from 'moment';
import { dateFormats } from '../util/constants';

const sessionDates = (session) => {
  if (session) {
    const { start: sessionStart, end: sessionEnd } = session;

    const start = moment(sessionStart, dateFormats.ISO_8601);
    const end = moment(sessionEnd, dateFormats.ISO_8601);

    let startDate;
    let endDate;

    if (start.month() === end.month()) {
      startDate = start.format('MMMM D');
      endDate = end.format('D');
    } else {
      startDate = start.format('MMMM D');
      endDate = end.format('MMMM D');
    }

    return `(${startDate} - ${endDate})`;
  } else {
    return null;
  }
};

const sessionNameWithDates = (session) => {
  const { name } = session;

  return `${name} ${sessionDates(session)}`;
};

export {
  sessionDates,
  sessionNameWithDates
};



// WEBPACK FOOTER //
// ./src/js/filters/SessionFilters.js